import { track } from '@bnnvara/analytics/src/track';
import { Dropdown, DropdownItem, DropdownList } from '@bnnvara/hub';
import PropTypes from 'prop-types';
import React from 'react';

import { notificationType } from '../notificationType';
import { NotificationDropdownItem } from './NotificationDropdownItem';
import { NotificationsDropdownGroup } from './NotificationsDropdownGroup/NotificationsDropdownGroup';
import * as S from './styled';

const NotificationsDropdown = ({
  notifications,
  groupedNotifications,
  setNotificationsOnRead,
  isLoading,
  unreadCount,
  login,
  register,
  isLoggedIn,
  children,
}) => {
  const hasNotifications = notifications.length > 0;
  const showGrouped = !isLoading && groupedNotifications.length > 1;
  const showUnGrouped = !isLoading && groupedNotifications.length === 1;
  const showNoNotificationsText = !isLoading && !hasNotifications && isLoggedIn;

  const onLoginClick = () => {
    track('Login-Registreer', 'click', 'notifications-dropdown');
    login();
  };

  const onRegisterClick = () => {
    register();
  };

  return (
    <Dropdown
      title="Jouw inbox"
      subtitle={isLoggedIn ? `(${unreadCount})` : null}
      ariaLabel="Jouw persoonlijke notificaties"
      controls={isLoggedIn && children}
    >
      <DropdownList
        /**
         * It is possible that the state is loading, and there are already notifications
         * For example, when receiving a notification from the websocket.
         */
        isLoading={isLoading && !hasNotifications}
      >
        {showNoNotificationsText && (
          <DropdownItem title="Je hebt nog geen notificaties" as="span" />
        )}
        {!isLoggedIn && (
          <DropdownItem>
            Mis nooit meer nieuwe informatie over jouw favoriete BNNVARA titels!
            Volg een titel en krijg direct updates op de website en/of in je
            mail! Login of registreer om te beginnen met volgen!
            <S.LoginButton onClick={onLoginClick}> Login</S.LoginButton>
            <S.RegisterButton onClick={onRegisterClick}>
              Register
            </S.RegisterButton>
          </DropdownItem>
        )}

        {showGrouped &&
          groupedNotifications.map((group) => {
            return (
              <NotificationsDropdownGroup
                key={group.name}
                name={group.name}
                type={group.type}
                themeSlug={group?.themeSlug}
                notifications={group.notifications}
                unreadCount={group.unreadCount}
                setNotificationsOnRead={setNotificationsOnRead}
              />
            );
          })}

        {showUnGrouped &&
          groupedNotifications[0].notifications.map((item) => {
            const type = item?.themes?.length > 0 ? 'theme' : 'brand';

            return (
              <NotificationDropdownItem
                key={item.slug}
                type={type}
                setNotificationsOnRead={setNotificationsOnRead}
                {...item}
              />
            );
          })}
      </DropdownList>
    </Dropdown>
  );
};

NotificationsDropdown.propTypes = {
  notifications: PropTypes.arrayOf(notificationType),
  groupedNotifications: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      unreadCount: PropTypes.number,
      notifications: PropTypes.arrayOf(notificationType),
    })
  ),
  setNotificationsOnRead: PropTypes.func.isRequired,
  unreadCount: PropTypes.number,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  login: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

NotificationsDropdown.defaultProps = {
  notifications: [],
  isLoading: true,
};

export { NotificationsDropdown };
